export default __webpack_public_path__ + "static/media/coming-soon.a92f8096.png";